import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {CouponLandingPageHeaderLoadingDesktop} from './CouponLandingPageHeaderLoading.desktop';
import {
  CouponLandingPageHeaderViewDesktop,
  CouponLandingPageHeaderViewDesktopProps,
} from './CouponLandingPageHeaderView.desktop';
import {useCouponLandingPageHeader} from './useCouponLandingPageHeader';

export const CouponLandingPageHeaderDesktop: React.FC<
  CouponLandingPageHeaderViewDesktopProps
> = props => {
  return (
    <DataFetcher
      request={useCouponLandingPageHeader()}
      Error={null}
      View={CouponLandingPageHeaderViewDesktop}
      viewProps={props}
      Loading={() => (
        <CouponLandingPageHeaderLoadingDesktop className={props.className} />
      )}
    />
  );
};
